import { InvalidCredentialsError } from '~frontend-common/models/invalid-credentials-error';
import { useAuthStore } from '~web-portal/stores';

/**
 * Returns the auth details from the auth store
 */
export function getUserAuth() {
  const { userId, accessToken, isLoggedIn } = useAuthStore.getState();

  if (!isLoggedIn()) {
    throw new InvalidCredentialsError('User is not authenticated');
  }

  return { userId, accessToken };
}
